import React from 'react';

const StyledBox = ({ children, style }) => (
    <div style={style} className="base-page">
        {children}
    </div>
);

export default StyledBox;
